import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';
import PropTypes from 'prop-types';


function LayoutRoute({component: Component, protectors, ...rest}) {
    return (
        <Route
            {...rest}
            render={props => {
                try {
                    protectors.forEach((protector) => {
                        protector(props);
                    });
                } catch(e) {
                    if (e.fallBackTo) {
                        return <Redirect to={e.fallBackTo} />;
                    } else {
                        throw e;
                    }
                }

                return (
                    <ErrorBoundary>
                        <Component {...props} />
                    </ErrorBoundary>
                );
            }}
        />
    );
}

LayoutRoute.propTypes = {
    component: PropTypes.func,
    layout: PropTypes.func,
    protectors: PropTypes.arrayOf(PropTypes.func)
}

export default LayoutRoute;